import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'

const Navbar = () => {
  const router = useRouter()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const isActive = (path: string) => router.asPath === path

  return (
    <header className="flex items-center gap-6">
      <nav className="hidden items-center gap-6 md:flex">
        <Link href="/gnn">
          <a
            className={`text-sm font-medium transition-colors hover:text-blue-500 ${
              mounted && isActive('/gnn')
                ? 'font-semibold text-blue-500'
                : 'text-gray-700'
            }`}
          >
            Beranda
          </a>
        </Link>
        <Link href="/gnn/sumber-belajar">
          <a
            className={`text-sm font-medium transition-colors hover:text-blue-500 ${
              mounted && isActive('/gnn/sumber-belajar')
                ? 'font-semibold text-blue-500'
                : 'text-gray-700'
            }`}
          >
            Sumber Belajar
          </a>
        </Link>
      </nav>
    </header>
  )
}

export default Navbar
